<template>
  <div>
    <div>
      <div class="flex self-end">
        <vs-button icon="personadd" class="rounded-lg" @click="create()"
          >New Customer</vs-button
        >
      </div>
      <div class="py-2">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search customer"
          class="
            mb-4
            w-full
            md:w-1/2
            last:mb-0
            border border-gray-700
            focus:outline-none
            focus:ring
            rounded-lg
            w-8/12 h-10
          "
        />
      </div>
    </div>
    <!-- <div class="flex flex-wrap float-right my-4 space-x-1"> -->

    <!-- </div> -->
    <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-2 gap-y-1">
      <div
        v-for="customer in resultQuery"
        :key="customer.name"
        class="
          pl-2 py-1 
          shadow-md
          opacity-95
          flex flex-row
          justify-start
          rounded-lg
          h-16 w-full
          text-gray-700
        "
        @click="loadUserCustomer(customer)"
      >
        <div
          :class="{
            'font-bold underline ':
              $store.getters.userCustomer === customer.name,
          }"
          class="flex flex-row w-11/12 pr-4 hover:underline"
        >
          <div>
            <img
              src="@/assets/images/logo/blank_profile.png"
              :alt="customer.name"
              class="object-cover w-6 h-6 mr-4 rounded-full"
            />
          </div>
          <div>
            <div>
              <span class="align-bottom text-left w-full h-8 ">
                {{ customer.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="h-1 flex flex-end space-x-2">
          <vs-button
            v-if="$store.getters.userCustomer === customer.name"
            class="md:mb-0 x-2 rounded-lg bg-blue-50"
            type="line"
            icon-pack="feather"
            icon="icon-plus"
            to="/add-order"
            title="Add order"
          ></vs-button>
          <vs-button
            v-if="$store.getters.userCustomer === customer.name"
            class="md:mb-0 x-2 rounded-lg bg-blue-50"
            type="line"
            icon-pack="feather"
            icon="icon-file"
            to="/orders"
            title="View orders"
          ></vs-button>
        </div>
      </div>
    </div>
    <br />
    <template>
      <transition
        enter-active-class="transition-all duration-150 ease-in-out transform"
        leave-active-class="transition-all duration-100 ease-in-out transform"
        enter-class="translate-y-full"
        enter-to-class="translate-y-0"
        leave-class="translate-y-0"
        leave-to-class="translate-y-full"
      >
        <slot />
        <div
          v-if="createCustomer"
          class="
            bg-white
            pl-8
            rounded-lg
            bottom-2
            inset-x-0
            fixed
            z-20
            top-1
            sticky
            shadow-lg
          "
        >
          <div class="mb-4">
            <h4 class="mb-4 pt-4">
              Customer Details
            </h4>
          </div>

          <div>
            <vs-input
              name="user"
              icon-no-border
              icon="icon icon-user"
              icon-pack="feather"
              label-placeholder="User"
              v-model="user"
              class="w-8/12"
            />
            <vs-input
              type="email"
              name="email"
              icon-no-border
              icon="icon icon-mail"
              icon-pack="feather"
              label-placeholder="Email"
              v-model="email"
              class="w-8/12"
            />
            <vs-input
              type="password"
              name="password"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Password"
              v-model="password"
              class="w-8/12 mt-6"
            />
            <vs-input
              type="password"
              name="password"
              icon-no-border
              icon="icon icon-lock"
              icon-pack="feather"
              label-placeholder="Confirm password"
              v-model="repassword"
              class="w-8/12 mt-6"
            />
          </div>
          <div class="flex flex-wrap my-4 space-x-1">
            <vs-button class="float-right rounded-lg" @click="validateUser()"
              >Create</vs-button
            >
            <vs-button
              class="float-right rounded-lg"
              v-if="createCustomer"
              @click="cancel"
              >Cancel</vs-button
            >
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      customers: [],
      searchQuery: null,
      createCustomer: false,
      company: "",
      name: "Add",
      user: "",
      email: "",
      password: "",
      repassword: "",
      email_reg:
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.customers.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        return this.customers;
      }
    },
  },
  methods: {
    createOrder() {
      this.$router.push({ name: "add-order" });
    },
    viewOrder() {
      this.$router.push({ name: "orders" });
    },
    cancel() {
      this.createCustomer = false;
      this.name = "Add";
    },
    create() {
      this.createCustomer = true;
      (this.user = ""),
        (this.email = ""),
        (this.password = ""),
        (this.repassword = "");
    },
    validateUser() {
      if (this.user == "") {
        this.alertUser("danger", "Please enter your username");
      } else if (this.email == "") {
        this.alertUser("danger", "Please enter your email");
      } else if (this.email_reg.test(this.email) == false) {
        this.alertUser("danger", "Please enter a vaild email");
      } else if (this.password == "") {
        this.alertUser("danger", "Please enter a password");
      } else if (this.password.length < 6) {
        this.alertUser(
          "danger",
          "Password must be at least 6 characters long",
          4000
        );
      } else if (this.repassword == "") {
        this.alertUser("danger", "Please confirm your password");
      } else if (this.password != this.repassword) {
        this.alertUser(
          "danger",
          "Password and confirmation password do not match"
        );
      } else {
        this.createMyUser();
      }
    },
    async createMyUser() {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/createMyUser"
      );

      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
      urlWithParams.searchParams.append(
        "name",
        `${this.$store.getters.userNameDomain.split(".")[0]}.${this.user}`
      );
      urlWithParams.searchParams.append("password", this.password);
      urlWithParams.searchParams.append("email", this.email);
      urlWithParams.searchParams.append("usertype", "2");

      const promise = await fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const response = await promise.json();
      if (response.status !== 1) {
        this.alertUser("success", "Customer Added Successfully");
        this.customers.push({ name: this.user });
        setTimeout(() => {
          this.createCustomer = false;
        }, 2000);
      } else {
        this.alertUser("danger", response.message);
      }
    },
    getCustomers() {
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/getMyCustomers"
      );
      urlWithParams.searchParams.append("Page", 1);
      urlWithParams.searchParams.append("size", 10);
      urlWithParams.searchParams.append("filter", "Ordered");
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      fetch(urlWithParams.href, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.customers = data.customers;
        });
    },
    navigate_to_detail_view() {},
    loadUserCustomer(customer) {
      this.createCustomer = false;
      this.$store.commit("UPDATE_USER_CUSTOMER", customer.name);
      this.$emit("customerChange", customer.name);
    },
  },
  mounted() {
    this.getUserDetails();
    this.getCustomers();
  },
};
</script>